import { render } from "./vonderzeit.vue?vue&type=template&id=24e6822e"
import script from "./vonderzeit.vue?vue&type=script&lang=js"
export * from "./vonderzeit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__